import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialCallCenterContactHelp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 14.48h-1.52v-1.53H25.9V5.34h-1.52v18.28h1.52v4.57h1.53v-3.05h1.52v-1.52h1.52V22.1H32V16h-1.53Zm-3.04 7.62H25.9v-7.62h1.53Zm-6.1 6.09h4.57v1.53h-4.57Zm1.52-24.38h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52h-1.52ZM10.66.76h10.67v1.53H10.66Z\"/><path fill=\"currentColor\" d=\"M16.76 29.72h4.57v1.52h-4.57Zm0-3.05h4.57v1.52h-4.57Zm-1.52 1.52h1.52v1.53h-1.52Zm-6.1-25.9h1.52v1.52H9.14ZM7.62 3.81h1.52v1.53H7.62Zm-1.53 9.14H3.05v1.53H1.52V16H0v6.1h1.52v1.52h1.53v1.52h3.04v-1.52h1.53V5.34H6.09Zm0 9.15H4.57v-7.62h1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialCallCenterContactHelp
